import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';

import SearchContent from './Content';

const queryClient = new QueryClient();

interface TopEntity {
  id: number;
  name: string;
  following: boolean;
}

interface TopRelatedEntity {
  matchingEntity: boolean;
  name: string;
}

export type SearchScope = 'articles' | 'directory' | 'forum';

export interface SearchPageProps {
  articleContent: ArticleOrBriefing[];
  isSignedIn: boolean;
  page: number;
  pageCount?: number;
  query?: string;
  scope: SearchScope;
  title: string;
  topEntities?: Array<TopEntity>;
  topRelatedEntities: Array<TopRelatedEntity>;
}

const SearchPage = (props: SearchPageProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SearchContent {...props} />
    </QueryClientProvider>
  );
};

export default SearchPage;
